import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { apisiseci } from "../../api";
import { Totem } from "../../../@types/totem";
import { useHistory } from "react-router-dom";

export type TotemDuplicateData = Pick<
    Totem,
    | "id"
    | "descricao"
    | "cor_fonte"
    | "cor_fundo"
    | "token"
    | "senha_reset"
> & {
    local_atendimento: string
    orgao: number
    servicos: Array<string>
    prioridades: Array<string>
    logo: File
};

export function useTotemDuplicate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        Totem,
        AxiosError<{ detail: string }>,
        TotemDuplicateData
    >({
        mutationKey: ["totem", "duplicate"],
        mutationFn: async (data) => {
            const payload = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                if (value instanceof File) {
                    payload.append(key, value);
                } else if (Array.isArray(value)) {
                    if (value.length === 1) {
                        payload.append(key, String(value[0]) + ',');
                    } else {
                        payload.append(key, String(value));
                    }
                } else {
                    payload.append(key, String(value));
                }
            });

            payload.delete("orgao");
            payload.append("orgao_id", String(data.orgao));

            const response = await apisiseci.post<Totem>(
                '/cms/totens-duplicar/', payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    }
                }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Totem duplicado com sucesso!");
            await queryClient.invalidateQueries({ queryKey: ["totem", "list"] });
            history.push(`/totens`);
        },
        onError: (error) => {
            toast.error(error?.response?.data?.detail || "Algo deu errado, tente novamente!");
            console.log(error);
        },
    });

    return mutation;
}
